<template>
  <div v-if="startClicked" class="main">
    <div class="top-container">
      <div class="buttons-container">
        <div
          class="question-row"
          v-for="(question, index) in questions"
          :key="index"
          @click="onLetter(question)"
        >
          <h1>{{ question.letter }}</h1>
        </div>
      </div>
      <div class="bottom-button-container">
        <button @click="onFinishButton">课程结束</button>
      </div>
    </div>

    <v-dialog width="80%" />

    <div class="finish-button"></div>

    <loading :active.sync="loading" :height="40" :width="40"></loading>

    <div v-if="items" class="overlay">
      <div class="overlay-header">
        <p>【{{ slectedYin }}】选择题目</p>
        <button @click="onBack">返回</button>
      </div>
      <div class="selected-items-container">
        <div class="inner">
          <div class="item-container" v-for="item in items" :key="item.id">
            <button
              v-bind:style="
                selectedWord === item.name
                  ? 'background-color: #A4A9B2'
                  : 'background-color: white'
              "
              @click="onWord(item)"
            >
              {{ item.name }}
            </button>
          </div>
        </div>
      </div>
      <div class="bottom-controls">
        <div class="left">
          <div class="big-thumb">
            <button @click="onControlButton('big-thumb')">大赞</button>
          </div>
          <div class="small-thumb">
            <button @click="onControlButton('small-thumb')">小赞</button>
          </div>
          <div class="no-thumb">
            <button @click="onControlButton('no-thumb')">不赞</button>
          </div>
        </div>
        <div class="right">
          <button @click="onControlButton('big-dift')">
            <div class="big-dift">
              <span>大</span><span>飞</span><span>船</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="showStart" class="start-button-container">
    <button @click="onStartButton" class="start-button">开始</button>

    <loading :active.sync="loading" :height="40" :width="40"></loading>
  </div>
  <div v-else>
    <loading :active.sync="loading" :height="40" :width="40"></loading>
  </div>
</template>
<script>
import MiniCore from 'easemob-websdk/miniCore/miniCore';
import question2s from '../static/swam_t_questions.json';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { portalUrl } from '../static/config';
import { setTimeout } from 'timers';
import moment from 'moment';
import queryString from 'query-string';

const tableRows = [
  'd',
  'm',
  'n',
  'h',
  't',
  'b',
  'g',
  'k',
  'j',
  'q',
  'x',
  'f',
  'l',
  'p',
  's',
  'r',
  'c',
  'z',
  'ch',
  'zh',
  'sh',
  'w',
  'y',
];

export default {
  data() {
    return {
      startClicked: false,
      showStart: false,
      questions: [],
      counter: 0,
      loading: false,
      items: undefined,
      selectedWord: undefined,
      slectedYin: undefined,
      birthay: new Date().toISOString().slice(0, 10),
      name: '',
      deviceInited: false,
      max: moment().subtract(3, 'years').toDate(),
    };
  },

  components: {
    Loading,
  },

  mounted() {
    const letters = [];

    tableRows.forEach((t) => {
      const found = letters.findIndex((l) => l.letter === t);
      if (found < 0) {
        letters.push({
          letter: t,
          items: question2s.filter((f) => f.initial === t),
        });
      }
    });

    this.questions = letters;

    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);

    this._deviceId = searchParams.device_id;
    this._testId = searchParams.test_id;
    this._token = searchParams.token;

    this._showLetters = searchParams.in_process === 'true';

    this.miniCore = new MiniCore({
      appKey: '1132240814153544#bethelswamcrecovery',
    });

    const localData = localStorage.getItem(this._testId);

    if (localData === null || localData === '' || localData === undefined) {
      this._learningFlows = [];
    } else {
      this._learningFlows = JSON.parse(localData);
    }

    this._canClick = true;

    this.loading = true;

    this.miniCore
      .registerUser({
        username: `${this._deviceId}_control`,
        password: `${this._deviceId}_control`,
      })
      .then((rRes) => {
        console.log('----rRes', rRes);
        this.miniCore
          .open({
            username: `${this._deviceId}_control`,
            password: `${this._deviceId}_control`,
          })
          .then((res) => {
            this.loading = false;
            if (this._showLetters) {
              this.startClicked = true;
            } else {
              this.showStart = true;
            }
            console.log('-----login_res', res);
          })
          .catch((err) => {
            this.loading = false;
            console.log('------em login', err.type, err);
            if (err.type === 1) {
              if (this._showLetters) {
                this.startClicked = true;
              } else {
                this.showStart = true;
              }
            } else {
              console.log('-------err', err);
            }
          });
      })
      .catch((rError) => {
        console.log('----rError', rError);
        if (rError.type === 17) {
          this.miniCore
            .open({
              username: `${this._deviceId}_control`,
              password: `${this._deviceId}_control`,
            })
            .then((res) => {
              this.loading = false;
              if (this._showLetters) {
                this.startClicked = true;
              } else {
                this.showStart = true;
              }

              console.log('-----login_res', res);
            })
            .catch((err) => {
              this.loading = false;
              console.log('------em login', err.type, err);
              if (err.type === 1) {
                if (this._showLetters) {
                  this.startClicked = true;
                } else {
                  this.showStart = true;
                }
              } else {
                console.log('-------err', err);
              }
            });
        }
      });

    this.miniCore.addEventHandler(this._deviceId, {
      onTextMessage: (message) => {
        console.log('-----message', message);
        if (message.msg === 'inited') {
          this.deviceInited = true;
        }
      },
    });
  },

  methods: {
    onNextButton() {
      const option = {
        chatType: 'singleChat',
        type: 'txt',
        to: this._deviceId,
        msg: 'go_next',
        deliverOnlineOnly: true,
      };
      const msg = this.miniCore.Message.create(option);
      this.miniCore
        .send(msg)
        .then((res) => {
          console.log('发送成功', res, msg);
        })
        .catch((err) => {
          console.log('发送失败', err);
        });
    },

    onAnimationButton() {
      const option = {
        chatType: 'singleChat',
        type: 'txt',
        to: this._deviceId,
        msg: 'boom',
        deliverOnlineOnly: true,
      };
      const msg = this.miniCore.Message.create(option);
      this.miniCore
        .send(msg)
        .then((res) => {
          console.log('发送成功', res, msg);
        })
        .catch((err) => {
          console.log('发送失败', err);
        });
    },

    onControlButton(e) {
      if (this.selectedWord && this._canClick) {
        this._canClick = false;
        const option = {
          chatType: 'singleChat',
          type: 'txt',
          to: this._deviceId,
          msg: e,
          deliverOnlineOnly: true,
        };

        const foundIndex = this._learningFlows.findIndex(
          (l) => l.word === this.selectedWord
        );

        if (foundIndex >= 0) {
          const _foundWord = this._learningFlows[foundIndex];

          _foundWord.actions = [..._foundWord.actions, { action_name: e }];

          this._learningFlows[foundIndex] = _foundWord;
        }

        // store flow to local
        localStorage.setItem(this._testId, JSON.stringify(this._learningFlows));

        const msg = this.miniCore.Message.create(option);

        this.miniCore
          .send(msg)
          .then(() => {
            setTimeout(() => (this._canClick = true), 600);
          })
          .catch((err) => {
            setTimeout(() => (this._canClick = true), 600);
            console.log('发送失败', err);
          });
      }
    },

    onLetter(x) {
      const option = {
        chatType: 'singleChat',
        type: 'txt',
        to: this._deviceId,
        msg: 'add-star',
        deliverOnlineOnly: true,
      };

      const msg = this.miniCore.Message.create(option);

      this.miniCore
        .send(msg)
        .then(() => {
          console.log('------发送成功');
        })
        .catch((err) => {
          console.log('发送失败', err);
        });

      this.slectedYin = x.letter;
      this.items = x.items;
    },

    onBack() {
      this.selectedWord = undefined;
      this.items = undefined;
    },

    onWord({ name, id }) {
      const foundIndex = this._learningFlows.findIndex((l) => l.word === name);

      if (foundIndex < 0) {
        this._learningFlows.push({
          word: name,
          initial: this.slectedYin,
          actions: [],
        });
      }

      // store flow to local
      localStorage.setItem(this._testId, JSON.stringify(this._learningFlows));

      this.selectedWord = name;

      const obj = { action: 'change_word', card_id: id };

      const option = {
        chatType: 'singleChat',
        type: 'txt',
        to: this._deviceId,
        msg: JSON.stringify(obj),
        deliverOnlineOnly: true,
      };

      const msg = this.miniCore.Message.create(option);

      this.miniCore
        .send(msg)
        .then(() => {
          console.log('------发送成功');
          this.startClicked = true;
        })
        .catch((err) => {
          console.log('发送失败', err);
        });
    },

    onStartButton() {
      const option = {
        chatType: 'singleChat',
        type: 'txt',
        to: this._deviceId,
        msg: `start`,
        deliverOnlineOnly: true,
      };

      const msg = this.miniCore.Message.create(option);

      this.miniCore
        .send(msg)
        .then(() => {
          console.log('------发送成功');
          this.loading = false;
          this.startClicked = true;
        })
        .catch((err) => {
          console.log('发送失败', err);
          this.loading = false;
        });
    },

    _updateTest(callBack) {
      this.loading = true;
      this.axios({
        url: `${portalUrl}swam/r/update`,
        headers: {
          token: this._token,
        },
        data: {
          test_id: this._testId,
          learning_flows: this._learningFlows,
        },
        method: 'POST',
      }).then((res) => {
        this.loading = false;
        callBack(res.data.success);
      });
    },
    onFinishButton() {
      this.$modal.show('dialog', {
        title: '提示',
        text: '是否结束本次的训练？',
        buttons: [
          {
            title: '取消',
            style: { color: 'white' },
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
          {
            title: '确定',
            handler: () => {
              this.loading = true;
              const option = {
                chatType: 'singleChat',
                type: 'txt',
                to: this._deviceId,
                msg: `end`,
                deliverOnlineOnly: true,
              };

              const msg = this.miniCore.Message.create(option);

              this.miniCore
                .send(msg)
                .then(() => {
                  this.$modal.hide('dialog');
                  this._updateTest((suc) => {
                    if (suc) {
                      this.miniCore.close();
                      this.$router.replace({
                        path: '/swam_report',
                        query: {
                          flows: this._learningFlows,
                          test_id: this._testId,
                          token: this._token,
                        },
                      });
                    }
                  });
                })
                .catch((err) => {
                  console.log('发送失败', err);
                  this.loading = false;
                });
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  background-color: #e6e8eb;
  box-sizing: border-box;
  overflow-x: hidden;
}

.buttons-container {
  flex: 1;
  width: 100vw;
  overflow-y: scroll;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.bottom-button-container {
  height: 100px;
  /* background-color: #e6e8eb; */
  width: 100vw;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom);
  bottom: costant(safe-area-inset-bottom);
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom-button-container > button {
  width: 80vw;
  height: 60px;
  border-radius: 10px;
  background-color: white;
  color: #333;
}

.finish-button {
  width: 100vw;
  background-color: #e6e8eb;
  padding-bottom: costant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  align-items: center;
  justify-content: center;
}

.question-row {
  display: flex;
  width: 20vw;
  height: 20vw;
  justify-content: center;
  box-sizing: border-box;
  margin-left: 4vw;
  background-color: white;
  align-items: center;
  border-radius: 2vw;
  margin-top: 2.5vw;
  margin-bottom: 1vw;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2),
    1px 1px 2px 1px rgba(0, 0, 0, 0.19);
}

.question-row > h1 {
  text-align: left;
  color: #333;
  font-size: 8vw;
  font-family: Arial, Helvetica, sans-serif;
}

.buttons > button {
  width: 10vh;
  height: 10vh;
  border-radius: 5vh;
}

button {
  font-size: 25px;
  border: none;
  background-color: cadetblue;
  color: white;
}

.main-controls {
  width: 100vw;
  height: 90vh;
}

.questions {
  width: 100vw;
  height: 90vh;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.top-container {
  flex: 1;
  flex-direction: column;
  overflow-y: scroll;
  margin-bottom: 60px;
  background-color: #e6e8eb;
}

.buttons {
  height: 10vh;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100vw;
}

.item-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: cad;
  margin-top: 35px;
}

.name-item {
  width: 30vw;
  height: 15vw;
  margin-top: 2.5vw;
  margin-left: 2.5vw;
  background-color: cadetblue;
  border-radius: 2vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.name-item > h1 {
  text-align: left;
  color: white;
  font-weight: bolder;
  font-size: 10vw;
  font-family: Arial, Helvetica, sans-serif;
}

.back-button {
  margin-top: 20px;
  background-color: transparent;
  width: 30px;
  height: 30px;
}

.back-button > img {
  width: 30px;
  height: 30px;
  position: fixed;
  top: 10px;
  left: 20px;
}

.control-buttons {
  width: 100vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.input {
  height: 3vh;
  min-height: 40px;
  width: 80vw;
  margin-top: 20px;
  border-radius: 1.5vh;
  border-color: lightgray;
}

.header {
  width: 100vw;
  height: 40px;
}

.bottom-controls {
  background-color: #e6e8eb;
  flex: 1;
  width: 100vw;
  display: flex;
  flex-direction: row;
  padding: 6vw 6vw 6vh 6vw;
  box-sizing: border-box;
}

.bottom-controls > .left {
  flex: 2;
  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
}

.bottom-controls > .left > div {
  flex: 1;
}

.bottom-controls > .left > div > button {
  width: 100%;
  height: 100%;
  border-radius: 2vw;
}

.bottom-controls > .right {
  flex: 1;
  margin-left: 2vw;
}

.bottom-controls > .right > button {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 2vw;
}

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding-bottom: costant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #e6e8eb;
}

.overlay-header {
  width: 100vw;
  height: 60px;
  background-color: #e6e8eb;
  display: flex;
  flex-direction: row;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  font-size: 6vw;
  font-weight: bold;
}
.overlay-header > button {
  width: 80px;
  height: 40px;
  font-size: 5vw;
  background-color: white;
  color: #333;
  border-radius: 10px;
}

.small-thumb {
  margin-top: 2vw;
  margin-bottom: 2vw;
}

.small-thumb > button {
  background-color: #7edf8b;
}

.big-thumb > button {
  background-color: #1a6720;
}

.no-thumb > button {
  background-color: #bcbcbc;
}

.big-dift {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.selected-items-container {
  flex: 1;
  overflow-y: scroll;
  /* align-items: center;
  justify-content: flex-start; */
}

.selected-items-container > .inner {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
}

.item-container {
  width: 28vw;
  height: 12vw;
  background-color: white;
  margin-left: 4vw;
  margin-bottom: 2vw;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2),
    1px 1px 2px 1px rgba(0, 0, 0, 0.19);
}

.item-container > button {
  width: 100%;
  height: 100%;
  margin-bottom: 0;
  background-color: white;
  color: #333;
  font-size: 5vw;
}

.start-button {
  width: 40vw;
  height: 40vw;
  border-radius: 20vw;
}

.start-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
}

.input-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input-row > input {
  width: 50vw;
  height: 40px;
  margin-left: 10px;
  border-radius: 4px;
  font-size: 20px;
}

.input-row > input:focus {
  outline: none !important;
  border: 1px solid cadetblue;
  color: #333;
}

.input-row > label {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.inputs-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 200px;
  justify-content: space-between;
  margin-top: 10vh;
}

.inputs-container > h1 {
  margin: 0;
  padding: 0;
  margin-bottom: 30px;
}

input[type='date'] {
  background-color: white;
  border: 1px solid #333;
  color: cadetblue;
}
</style>
